// The brand: the app icon's lamp silhouette in amber, then the name in the
// book serif, one colour. Size follows the surrounding font-size.
export function Wordmark({ size = "md" }: { size?: "sm" | "md" | "lg" }) {
  return (
    <span className={`wordmark ${size}`} aria-label="Pagemates">
      <svg className="wm-lamp" viewBox="0 0 64 64" aria-hidden="true">
        <g fill="currentColor"><path d="M23 10h18l9 20H14z" /><rect x="29.5" y="30" width="5" height="16" rx="1.5" /><path d="M18 54a14 4.5 0 0 1 28 0z" /></g>
      </svg>
      <span className="wm-text">Pagemates</span>
    </span>
  );
}
